var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class LanguageSelector extends Component {
    constructor() {
        super('LanguageSelector', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.btn-toggle-languages').on('click', () => {
                $('#language-selector').toggleClass('is-visible');
                $('#language-selector-overlay').toggleClass('opacity-0').toggleClass('pe-none');
            });
            $('#language-selector-overlay').on('click', () => {
                $('#language-selector').removeClass('is-visible');
                $('#language-selector-overlay').addClass('opacity-0').addClass('pe-none');
            });
            $('a.language').on('mouseenter', (event, link) => {
                const parent = link.parents('.language-column');
                parent.find('a.language').removeClass('fw-bold');
                parent.find('a.language .filler-language').addClass('opacity-0');
                link.addClass('fw-bold');
                link.find('.filler-language').removeClass('opacity-0');
                console.log('mouseenter', parent);
            });
            $('.language-column').on('mouseleave', (event, link) => {
                const parent = link.parents('.language-column');
                console.log('mouseleave', parent);
                parent.find('a.language').removeClass('fw-bold');
                parent.find('a.language .filler-language').addClass('opacity-0');
                $('a.language.is-current').addClass('fw-bold');
                $('a.language.is-current .filler-language').removeClass('opacity-0');
            });
            console.log('LanguageSelector initialized');
            this.success();
        });
    }
}
